import { useEffect } from "react";
import { Switch, Route } from "wouter";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";
import HomePage from "./pages/HomePage";
import BirthdayReminderHome from "./pages/BirthdayReminderHome";
import BirthdayReminderPrivacy from "./pages/BirthdayReminderPrivacy";
import BirthdayReminderSupport from "./pages/BirthdayReminderSupport";
import NotFound from "./pages/not-found";
import useDarkMode from "./hooks/useDarkMode";

function App() {
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  
  // Apply dark mode class to html element
  useEffect(() => {
    const htmlElement = document.documentElement;
    if (isDarkMode) {
      htmlElement.classList.add('dark');
    } else {
      htmlElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <div className="min-h-screen flex flex-col">
          <Switch>
            <Route path="/" component={() => <HomePage isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/birthdayreminder" component={BirthdayReminderHome} />
            <Route path="/birthdayreminder/privacy" component={BirthdayReminderPrivacy} />
            <Route path="/birthdayreminder/support" component={BirthdayReminderSupport} />
            <Route path="*" component={NotFound} />
          </Switch>
        </div>
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
